import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";

import {
    REQUEST_SPACES_LIST_ROOM_OS_DEVICES,
    REQUEST_SPACES_ADD_ROOM_OS_DEVICE,
    REQUEST_SPACES_UPDATE_ROOM_OS_DEVICE,
    REQUEST_SPACES_REMOVE_ROOM_OS_DEVICE,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/spaces/roomosMsgDefinitions";
import { RoomosHeader, RoomosHeaderDelete } from "userful-chronos-app-common-js/dist/models/spaces/roomos";
import "./roomosMsgReciever";

export const requestRoomosListConfig = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SPACES_LIST_ROOM_OS_DEVICES);
};

export const requestAddRoomosServer = (payload: RoomosHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SPACES_ADD_ROOM_OS_DEVICE, payload);
};

export const requestUpdateRoomosServer = (payload: RoomosHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SPACES_UPDATE_ROOM_OS_DEVICE, payload);
};

export const requestRemoveRoomosServer = (payload: string) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SPACES_REMOVE_ROOM_OS_DEVICE, payload);
};
